export class BrowserClipboard {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get browserRuntime() {
        return this.parent;
    }
    writeTextToClipboard(string) {
        navigator.clipboard.writeText(string);
        this.browserRuntime.app.message.info(`Kopieren in Zwischenablage erfolgreich`);
    }
}
